import { render } from "./DrugstoreForm2.vue?vue&type=template&id=2e30707f&scoped=true"
import script from "./DrugstoreForm2.vue?vue&type=script&lang=js"
export * from "./DrugstoreForm2.vue?vue&type=script&lang=js"

import "./DrugstoreForm2.vue?vue&type=style&index=0&id=2e30707f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e30707f"]])

export default __exports__